require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-neusiedl-parndorf.json") })
        }
      }, "path---betreuungseinrichtungen-neusiedl-parndorf");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-neusiedl-parndorf!./.cache/json/betreuungseinrichtungen-neusiedl-parndorf.json
// module id = 961
// module chunks = 231608221292675